import type { Sensor } from '../types';

export type SensoresFileFormatGuess = 'precalc' | 'raw' | 'unknown';

/**
 * Infiere si el Excel de sensores se procesó como CATMAN_PRECALC o CATMAN_RAW
 * a partir de metadatos y flags ya guardados en BD (sin nueva petición).
 */
export function inferSensoresFileFormat(sensores: Sensor[]): SensoresFileFormatGuess {
  if (!sensores.length) return 'unknown';

  const parseMeta = (raw: string | null | undefined): Record<string, unknown> | null => {
    if (!raw) return null;
    try {
      return JSON.parse(raw) as Record<string, unknown>;
    } catch {
      return null;
    }
  };

  const isPrecalcMeta = (m: Record<string, unknown> | null) =>
    m?.formato_origen === 'precalculado';

  for (const s of sensores) {
    if (s.has_precalculated_strain) return 'precalc';
    const sm = parseMeta(s.metadatos_adicionales);
    if (isPrecalcMeta(sm)) return 'precalc';
    if (s.variables?.length) {
      for (const v of s.variables) {
        if (v.has_precalculated_strain) return 'precalc';
        const vm = parseMeta(v.metadatos_adicionales);
        if (isPrecalcMeta(vm)) return 'precalc';
      }
    }
  }

  return 'raw';
}
